import { addYears, differenceInDays } from 'date-fns';
import { useMemo } from 'react';
import { sprintf } from 'sprintf-js';
import { styled } from 'styled-components';

import { Indicator } from '#/components/Indicator/Indicator';
import { useI18n } from '#/i18n/hooks/useI18n';
import { spacing } from '#/theme/theme';

const Spacer = styled.div`
  height: ${spacing[24]};
`;

export function ListingViewExpiredTag({
  expiredAt,
  isStaff,
}: {
  expiredAt?: Date;
  isStaff?: boolean;
}) {
  const { i18n } = useI18n();

  const labelText = useMemo(() => {
    if (isStaff) return i18n('This listing is not currently published');

    if (!expiredAt) return i18n('This listing has expired');

    const oneYearAfterExpiredAt = addYears(expiredAt, 1);
    const daysLeft = differenceInDays(oneYearAfterExpiredAt, new Date());

    if (daysLeft === 1)
      return i18n(
        'This page is visible for 1 more day. Copy and save the content if you would like to keep it for your own records.',
      );

    if (daysLeft > 1)
      return sprintf(
        'This page is visible for %(daysLeft)s more days. Copy and save the content if you would like to keep it for your own records.',
        { daysLeft },
      );

    return i18n('This listing has expired');
  }, [i18n, expiredAt, isStaff]);

  return (
    <>
      <Indicator iconName="error">{labelText}</Indicator>
      <Spacer />
    </>
  );
}
